export const isMobileDevice = ({ includeTablet = true }) => {
  const isMobile = /(Android|iPhone|mobile)/i.test(window.navigator.userAgent);
  const isTablet = /(tablet|iPad)|(android(?!.*mobile))/i.test(window.navigator.userAgent);

  return includeTablet ? isMobile : (isMobile && (!includeTablet && !isTablet));
};

export const isIOS = () => /(iPhone|iPad)/.test(window.navigator.userAgent);
export const isIPhone = () => /(iPhone)/.test(window.navigator.userAgent);

// Detects Safari browser by checking for "Safari" in UA while excluding other browsers that also contain "Safari"
// Chrome (Chrome), CriOS (Chrome iOS), EdgA (Edge iOS), FxiOS (Firefox iOS) all include "Safari" but aren't Safari
export const isSafari = () => /Safari/i.test(navigator.userAgent) && !/Chrome|CriOS|EdgA|FxiOS/i.test(navigator.userAgent);

// Desktop/Laptop and Desktop/Laptop + Touchscreen
export const isDesktopDevice = () => !window.matchMedia?.('(pointer:coarse)')?.matches;
